import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { setStoredEmailToken } from '@/auth/emailAuth';

/**
 * After SSO redirects to /auth/callback:
 * - If URL has ?token=... (e.g. SAML backend), store token and go to dashboard.
 * - Otherwise MSAL processes Azure AD response; wait for auth then redirect to dashboard.
 * - Only redirect to / after timeout when MSAL has finished (inProgress === None) and still not authenticated.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  useEffect(() => {
    const samlToken = searchParams.get('token');
    if (samlToken) {
      setStoredEmailToken(samlToken);
      navigate('/dashboard', { replace: true });
      return;
    }
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
      return;
    }
    // Don't give up while MSAL is still processing the redirect
    if (inProgress !== InteractionStatus.None) return;
    const t = setTimeout(() => navigate('/', { replace: true }), 2000);
    return () => clearTimeout(t);
  }, [isAuthenticated, inProgress, navigate, searchParams]);

  return (
    <div className="login-page">
      <div className="login-card">
        <p className="page-muted">Signing you in…</p>
      </div>
    </div>
  );
}
